/* Stylesheet */

.grid_container {
  padding: 0;
  height: 100%;

  .row {
    padding: 0;
    height: 100%;

    .col {
      padding: 0;
    }

    .illustration_container_col {
      .wrapper_container {
        height: 100%;
        overflow: hidden;
        border-radius: 0% 5% 15% 0% / 0% 50% 100% 0%;
      }
    }

    .credentials_container {
      padding: 32px 0px 32px 0px;
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;

      .block_container {
        width: 80%;
      }
    }
  }
}

/* Media Queries */
@media screen and (min-width: 576px) {
  .grid_container {
    .row {
      .credentials_container {
        .block_container {
          width: 70%;
        }
      }
    }
  }
}
